import RefundPolicyContent from "./refund_policy.mdx";
export default function RefundPolicy() {
  return (
    <div>
      <RefundPolicyContent />
    </div>
  );
}
